

























































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import authProvider from '@/utility/authProvider';
import { DATA } from '@/config/data';
import formatNumber from '@/shared/filters/format-number';
import { DepositModel } from '@/models/deposit';
import { BillOfLadingModel } from '@/models/bill-of-lading';
import orderServices from '@/services/order-service';

@Component
export default class BillOfLading extends Vue {
    @Prop({ default: () => new DepositModel() })
    private deposit!: DepositModel;

    @Prop({ default: null })
    private depositId!: number;

    @Prop({ default: 0 })
    private feeWeight!: number;

    private listBillOfLading: BillOfLadingModel[] = [];

    @Watch('depositId', { immediate: true, deep: true })
    private async watchOrderId() {
        if (this.depositId) {
            await this.loadData();
        }
    }

    private async loadData() {
        const result = await orderServices.getBillOfLading(this.depositId, 1, authProvider.getToken());
        this.listBillOfLading = [];
        if (result && result.status === 200 && result.data.data) {
            const orderTransactions = result.data.data.order_transactions;

            for (const item of orderTransactions) {
                const bill = new BillOfLadingModel();
                bill.createdBy = item.CreatedBy;
                bill.createdDate = item.CreatedDate;
                bill.id = item.ID;
                bill.modifiedBy = item.ModifiedBy;
                bill.modifiedDate = item.ModifiedDate;
                bill.orderCodeId = item.OrderCodeID;
                bill.orderId = item.OrderID;
                bill.transactionCode = item.TransactionCode;
                bill.productName = item.ProductName;
                bill.productAmount = item.ProductAmount;
                bill.numberOfPack = item.NumberOfPack;
                bill.productNumber = item.ProductNumber;
                bill.packageType = item.PackageType;
                bill.status = item.Status;
                bill.statusDetail = DATA.billOfLadingStatus.find(x => x.value === item.Status) || { value: 0, name: 'Khác', color: '#3b4354' };
                bill.uId = item.UID;
                bill.userName = item.Username;
                bill.weight = item.Weight > 0 ? `${formatNumber(item.Weight, '0,0.[0000]')} kg` : '';
                bill.weightByVolume = item.WeightByVolume > 0 ? `${formatNumber(item.WeightByVolume, '0,0.[0000]')} kg` : '';
                bill.volume = item.Width > 0 ? `${item.Length}cm x ${item.Width}cm x ${item.Height}cm` : '';
                
                bill.Length = item.Length;
                bill.Width = item.Width;
                bill.Height = item.Height;
                bill.Volume = item.Volume;
                bill.Weight = item.Weight;
                bill.WeightByVolume = item.WeightByVolume;
                bill.FeeWeight = item.FeeWeight;
                bill.OrderNote = item.OrderNote;
                bill.StoreVNNote = item.StoreVNNote;
                bill.TransactionCode = item.TransactionCode;

                this.listBillOfLading.push(bill);
            }
        }
    }

    private getFeeWeight(item: any): number {
        if (item.FeeWeight && item.FeeWeight > 0) {
            return item.FeeWeight;
        }
        return this.feeWeight || 0;
    }

    public getChargeableWeightUnit(item: any) {
        return this.deposit && this.deposit.feeShipType === 1 ? 'm³' : 'kg';
    }

    private getChargeableWeight(item: any): number {
        const weight = item.Weight || 0;
        const weightByVolume = item.WeightByVolume || 0;
        const feeShipType = this.deposit ? this.deposit.feeShipType : 0;
        return feeShipType === 0 ? weight : feeShipType === 1 ? item.Volume : weightByVolume;
    }

    private getShippingFee(item: any): number {
        const chargeableWeight = this.getChargeableWeight(item);
        const feeWeight = this.getFeeWeight(item);
        return chargeableWeight * feeWeight;
    }

    get totalShippingFee(): number {
        if (!Array.isArray(this.listBillOfLading)) {
            return 0;
        }
        return this.listBillOfLading.reduce((sum: number, item: any) => sum + this.getShippingFee(item), 0);
    }

    private formatDimension(item: any): string {
        if (item && (item.Length > 0 || item.Width > 0 || item.Height > 0)) {
            return `${formatNumber(item.Length || 0, '0,0')} x ${formatNumber(item.Width || 0, '0,0')} x ${formatNumber(item.Height || 0, '0,0')}`;
        }
        return '';
    }

    private transformNumb(value: number, format: string) {
        if (!(value > 0)) {
            return '0';
        }
        return formatNumber(value, format);
    }
}
